import React from "react";
import styles from "../styles.module.scss";
import { useTranslation } from "react-i18next";
import useGetData from "hooks/api/useGetData";
import { useParams } from "react-router-dom";
import { DRAWER_FLOW_TYPE } from "constants/flowTypes";
import { useFormContext } from "react-hook-form";
import { formatFieldName } from "utils/formatFieldName";
import { useAppContext } from "context/AppContext";

const SchoolPage2: React.FC = ({ ...rest }) => {
  const { t } = useTranslation();
  const { drawerData } = useGetData();
  const { type: flowType } = useParams();
  const { watch } = useFormContext();
  const formValues = watch();
  const appContext = useAppContext();
  const { i18n } = useTranslation();

  return (
    <div className={styles.thirdScreenWrapper}>
      {/* Payment Details Section */}

      <div className={styles.paymentContainer}>
        <h2 className={styles.sectionTitle}>{t("secondScreen.heading3")}</h2>
        {flowType === DRAWER_FLOW_TYPE &&
          drawerData?.customer.map((field) => (
            <>
              <div className={styles.detailRow}>
                <span style={{ whiteSpace: "nowrap" }} key={`${field.name}_review_text`}>{formatFieldName(field?.label?.find((l) => l.lang === i18n.language)?.text || "")}:</span>
                <span className={styles.detailRowValues} key={`${field.name}_review`}>
                  {formValues[field.name]
                  ? formValues[field.name]
                  : field.name === "feeName"
                  ? drawerData?.name
                  : ""}
                </span>
              </div>
            </>
          ))}
        <div className="m-divider-dashed-order mb-3"></div>
        {drawerData?.firstScreenFields.map((field) => (
          <>
            <div className={styles.detailRow}>
              <span key={field.name}>{formatFieldName(field?.label?.find((l) => l.lang === i18n.language)?.text || "")}:</span>
              <span className={styles.detailRowValues} key={`${field.name}_review_value`}>
                {formValues[field.name]
                ? new Intl.NumberFormat("fr-FR").format(formValues[field.name])
                : ""}{" "} FCFA
              </span>
            </div>
          </>
        ))}
        {/* fees and payment number */}
        <div className={styles.detailRow}>
          <span style={{ whiteSpace: "nowrap" }} key={"fee"}>{t("secondScreen.feeText")}:</span>
          <span className={styles.detailRowValuefee} key={"fee_value"}>
            {t("secondScreen.feesInfo")}
          </span>
        </div>
        <div className={styles.detailRow}>
          <span key={"phone"}>{t("secondScreen.phoneNumber")}:</span>
          <span className={styles.detailRowValues} key={"phone_value"}>
            {appContext?.paymentInput}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SchoolPage2;
